import { createStyles, keyframes } from '@mantine/core';
import { FindFactionColor } from '../../factionalwarfare/FactionColors.js';
var pulse = keyframes({
  "from, to": {
    opacity: 1
  },
  "50%": {
    opacity: 0.5
  }
});
var useStyles = createStyles(function (_theme, _ref) {
  var headerBackgroundColor = _ref.headerBackgroundColor;
  var amarr = FindFactionColor("amarr");
  var caldari = FindFactionColor("caldari");
  var gallente = FindFactionColor("gallente");
  var minmatar = FindFactionColor("minmatar");
  var angel = FindFactionColor("angel");
  var guristas = FindFactionColor("guristas");
  return {
    root: {
      width: "100%",
      color: "white",
      fontSize: "18px",
      fontWeight: 400,
      "& tbody tr td": {
        fontSize: "18px"
      },
      "& th, & td": {
        cursor: "pointer",
        whiteSpace: "nowrap"
      }
    },
    headerCell: {
      padding: "0.25rem 10px",
      fontSize: "18px",
      "& > div": {
        display: "flex",
        gap: "5px",
        fontSize: "18px"
      }
    },
    sortIcon: {
      display: "inline-block",
      width: "10px"
    },
    amarr: {
      "--factionColor": amarr
    },
    caldari: {
      "--factionColor": caldari
    },
    gallente: {
      "--factionColor": gallente
    },
    minmatar: {
      "--factionColor": minmatar
    },
    angel: {
      "--factionColor": angel
    },
    guristas: {
      "--factionColor": guristas
    },
    heading: {
      width: "100%",
      fontSize: "18px",
      backgroundColor: headerBackgroundColor,
      position: "sticky",
      top: 0,
      zIndex: 1
    },
    logo: {
      width: "28px",
      padding: "8px 0 2px !important"
    },
    factionHeaderCell: {
      "& div": {
        width: "10px"
      }
    },
    contestedHeaderCell: {
      "&[data-sort] div span": {
        display: "inline-block"
      },
      "& div": {
        justifyContent: "flex-end",
        "& span": {
          display: "none"
        }
      }
    },
    activeSystem: {
      animation: "".concat(pulse, " 1s ease-in-out 0.5s 5")
    },
    passiveSystem: {},
    columnContested: {
      "& > div > div": {
        "@media (max-width: 992px)": {
          display: "none"
        }
      },
      "& > div": {
        "@media (max-width: 992px)": {
          justifyContent: "center",
          textAlign: "center"
        }
      },
      "& span": {
        textAlign: "right",
        fontSize: "1.1rem",
        display: "inline-block",
        width: "4.5rem"
      }
    },
    columnAdvantage: {
      "& div": {
        fontSize: "16px"
      }
    },
    columnConstellation: {
      "@media (max-width: 992px)": {
        display: "none"
      }
    },
    selectedBackground: {
      "& [data-selected]": {
        backgroundColor: "#2C2E33"
      }
    },
    selectedText: {
      "& [data-selected]": {
        color: "var(--factionColor)",
        fontWeight: 500
      }
    }
  };
});
export { useStyles as default, pulse };